import ButtonCircle from '@/components/ButtonCircle';

type LinkProps = {
  extraClass?,
  buttonStyle?,
  link?: string;
  title?: string;
  arrowFill: string;
};

const Link: React.FC<LinkProps> = ({
  extraClass,
  buttonStyle,
  link,
  title,
  arrowFill
}) => {
  return (
    <a
      className={`button ${extraClass} ${buttonStyle ? `button--${buttonStyle}` : 'button--primary'}`}
      href={link}
    >
      {title}
      <ButtonCircle
        arrowFill={arrowFill}
        arrowHeight={13}
        arrowWidth={17}
      />
    </a>
  );
};

export default Link;
